// extracted by mini-css-extract-plugin
export default {"root":"PaymentMethods_root__TWsxn"};